const images = {
    logoNav: 'https://s3.amazonaws.com/project-static-assets/MergeSpreadsheets/Logo.png',
    loveLogo: 'https://project-static-assets.s3.amazonaws.com/LoveSpreadsheets/Logo.png',
    image404: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Longhaired_Dachshund_portrait.jpg/1006px-Longhaired_Dachshund_portrait.jpg',
    logoWhite: 'https://s3.amazonaws.com/project-static-assets/GetCleanData/LogoWhite.png',
    explainImage: "https://project-static-assets.s3.amazonaws.com/MergeSpreadsheets/mergeExplain.png",
};

export default images